import { FC, ChangeEvent } from 'react';
import { withStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import { Header } from '../Header';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import { Color } from '../Theme';
import { CompanyEditButton } from './CompanyEditButton';
import { Grid } from './CompanyGrid';
import DiamondIcon from 'mdi-react/DiamondIcon';

const StyledAccordion = withStyles({
  root: {
    border: 'none',
    borderTop: `2px solid ${Color.background}`,
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
    '&.Mui-disabled': {
      backgroundColor: 'transparent',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionDetails = withStyles((theme) => ({
  root: {
    display: 'block',
    padding: 0,
  },
}))(MuiAccordionDetails);

const Styled = {
  AccordionSummary: styled(MuiAccordionSummary)`
    &.Mui-expanded .MuiAccordionSummary-content svg {
      transform: rotate(0);
    }

    h2 {
      width: auto;
      margin: 0.9rem 0 0.9rem 1rem;
    }

    .MuiAccordionSummary-content {
      > svg {
        margin-left: 0.55rem;
        margin-top: 0.8rem;
        color: ${Color.primary};

        transform: rotate(-90deg);

        transition: transform 200ms ease;
      }

      > div {
        flex: 1;
        width: 100%;
      }
    }
  `,
  AccordionDetails: styled(AccordionDetails)`
    ${Grid} {
      margin-top: 0;
      padding-top: 0;
    }
  `,
};

export const CompanyAccordion: FC<{
  title: string;
  content: string | JSX.Element;
  expanded?: boolean;
  editable?: boolean;
  premium?: boolean;
  disabled?: boolean;
  onChange: (event: ChangeEvent<{}>, expanded: boolean) => void;
  onEdit?: () => void;
}> = ({ title, content, expanded, editable, premium, disabled, onChange, onEdit }) => (
  <StyledAccordion square expanded={!!expanded && !disabled} disabled={disabled} onChange={onChange}>
    <Styled.AccordionSummary>
      <ChevronDownIcon size={32} color={disabled ? Color.disabled : Color.primary} />
      <Header icon={premium && disabled ? <DiamondIcon color={Color.primary} /> : null}>{title}</Header>
      <div />
      {!!onEdit && !!editable && <CompanyEditButton onClick={onEdit} />}
    </Styled.AccordionSummary>
    <Styled.AccordionDetails>{!disabled && content}</Styled.AccordionDetails>
  </StyledAccordion>
);
